__webpack_public_path__ = process.env.WEBPACKER_ASSET_PATH
